import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Recording/Position_Schedule/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import ScheduleTable from 'components/Web_User_Interface/1440p_Series/Recording/Position_Schedule/positionSheduleTable';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "Aufgaben Menü // Position Zeitplan",
  "path": "/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Position_Zeitplan/",
  "dateChanged": "2024-09-19",
  "author": "Mike Polinowski",
  "excerpt": "Legen Sie einen Zeitplan für die Schwenk-, Neige- und Zoomposition Ihrer Kameras für bestimmte Wochentage und Tageszeiten fest. Speichern Sie die Kamerapositionen im Menü oberhalb des Live-Videos und verwenden Sie den Zeitplan, um sie zu automatisieren.",
  "image": "./WebUI_1440p_SearchThumb_Tasks_Position_Schedule.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Tasks_Position_Schedule.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title="Aufgaben Menü // Position Zeitplan" dateChanged="2024-09-19" author="Mike Polinowski" tag="INSTAR IP Camera" description="Legen Sie einen Zeitplan für die Schwenk-, Neige- und Zoomposition Ihrer Kameras für bestimmte Wochentage und Tageszeiten fest. Speichern Sie die Kamerapositionen im Menü oberhalb des Live-Videos und verwenden Sie den Zeitplan, um sie zu automatisieren." image='/images/Search/WebUI_1440p_SearchThumb_Tasks_Position_Schedule.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Tasks_Position_Schedule.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Web_User_Interface/1440p_Series/Recording/Position_Schedule/" locationFR="/fr/Web_User_Interface/1440p_Series/Recording/Position_Schedule/" crumbLabel="Video" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "aufgaben-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#aufgaben-men%C3%BC",
        "aria-label": "aufgaben menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aufgaben Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "konfigurieren-eines-zeitplans-für-die-ptz-position-der-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfigurieren-eines-zeitplans-f%C3%BCr-die-ptz-position-der-kamera",
        "aria-label": "konfigurieren eines zeitplans für die ptz position der kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfigurieren eines Zeitplans für die PTZ-Position der Kamera`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/47aef/1440p_Settings_Task_Pos_Schedule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACV0lEQVQoz2XQS08TUQCGYf6FLolKbwOaWFqibacz02mnnUtnOm2HtlA1aCAISAiiIApoohIvMagJEEO4JOItwaCJLohx48IF/qZXGTA1cfHmJGfx5DunTRAEhM5OQoGT9BiX0K9voYwskxldJT288l/i8Aq5sVX0iVec7pEpaFna29s5fvyYf7ZFIhEEoZPgqROI9gD9C2+p3dqgPrtJdWaDyvRRN9epTB9Wm92iefcdSdVGTIl0dZ1BiHQRDgt/QYFAIEjiXByvZPhVHZ2aa9FXdahXilTsPCUzh6Or2GYeu+xhag6SqCJLKoqcI9bdQ5v/ZB8MkEgmKdoOplXEdkpUqh59/U2/Wr3h3+cLup+u6/S5NXRNRpYUxFSG6Nn44cKDfDCRwCpaWJaF4zhUq1UajQb1RoP+/iaGYZJVVbRsFi2rMXLZoreSRkxKpMVMa+G/oG3aFItFHyyXy3ieR7VSpuG52IZG1tBRTIO8ZTE+mMfWU0iiRFZRiMXiR6AQIdARICWl8K54lF3Xxw6quCXKvU2cwXnMgRmGtCK3VY2hvMGLG1fpNRXktEhOVejujrUWBoNBorEokimR1woUCjqFgoGq5tBLda7NLTH9fJvNB4/YGR9leWKSj08fM+YWSIkiipQhGo21/jAcDvtosCNEMpEmmZDJSAoXXJ2NxSl+7q7xYWudX/vf2dvdZn/vE1/Xlpi/mCenyqRFhe5ovLUwFAr5RQSBxPk0mqIwUNaYH3R583CSH59f8+3LDi/vz7G0cIf3zxbZfnKPKU/Fc3KkkjLRP+BvxlGEGGuQdzQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/0eab22417e5e2f363e6bc59ff9a13dea/e4706/1440p_Settings_Task_Pos_Schedule.avif 230w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/d1af7/1440p_Settings_Task_Pos_Schedule.avif 460w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/7f308/1440p_Settings_Task_Pos_Schedule.avif 920w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/29832/1440p_Settings_Task_Pos_Schedule.avif 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/0eab22417e5e2f363e6bc59ff9a13dea/a0b58/1440p_Settings_Task_Pos_Schedule.webp 230w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/bc10c/1440p_Settings_Task_Pos_Schedule.webp 460w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/966d8/1440p_Settings_Task_Pos_Schedule.webp 920w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/0ca5b/1440p_Settings_Task_Pos_Schedule.webp 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/0eab22417e5e2f363e6bc59ff9a13dea/81c8e/1440p_Settings_Task_Pos_Schedule.png 230w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/08a84/1440p_Settings_Task_Pos_Schedule.png 460w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/c0255/1440p_Settings_Task_Pos_Schedule.png 920w", "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/47aef/1440p_Settings_Task_Pos_Schedule.png 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/0eab22417e5e2f363e6bc59ff9a13dea/c0255/1440p_Settings_Task_Pos_Schedule.png",
              "alt": "Web User Interface - 1440p Series - Recording",
              "title": "Web User Interface - 1440p Series - Recording",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ScheduleTable mdxType="ScheduleTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      